import UserManagementRepositoryImpl from './impl/UserManagementRepositoryImpl'

export default {
  getInstance () {
    return new UserManagementRepositoryImpl()
  }
}
